import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import * as ProductCompareHelper from '@project/shared/utils/product-compare/js/product-compare';
import getCurrentBreakpoint, { onBreakpointChange }  from '@project/shared/utils/breakpoints/js/breakpoints';

const classes = {
	headline: 'js-o-product-compare__headline',
	removebutton: 'js-o-product-compare__remove',
	removeAllbutton: 'js-o-product-compare__remove-all',
	backbutton: 'js-o-product-compare__back',
	productname: 'js-o-product-compare__productname',
	table: 'js-o-product-compare__table',
	tablerow: 'js-o-product-compare__table-row',
	tableDataRow: 'js-o-product-compare__data-row',
	tabletop: 'js-o-product-compare__table-top',
	fixedState: 'state-o-product-compare--fixed',
	tableHidden: 'state-o-product-compare--table-is-hidden',
	arrowsHidden: 'state-o-product-compare--arrows-is-hidden',
	titleTable: 'js-o-product-compare__title-table',
	fixedStateLeft: 'state-o-product-compare--fixed-left',
	miniTitle: 'js-o-product-compare__mini-title',
	categoryTitle: 'js-o-product-compare__category-title',
	categoryChild: 'js-o-product-compare__category-child',
	categoryTh: 'js-o-product-compare__category-th',
	categoryCollapse : 'state-o-product-compare--category-collapse',
	rightControl : 'js-o-product-compare__right-control',
	leftControl : 'js-o-product-compare__left-control',
	tableContent : 'js-o-product-compare__table-content',
	highlightRowActive : 'state-o-product-compare--highlight-row',
	showDifferences : 'js-o-product-compare__show-differences',
	showDifferencesActive: 'state-o-product-compare--show-differences',
	tooltipBtn: 'o-product-compare__tooltip',
	tooltipPopup: 'o-product-compare__tooltip-popup',
	tooltipCloser: 'js-m-tooltip__closer',

	favouriteBtn: "m-favourite-button",
	stateFavorBtnActive: "state-m-favourite-button--active",
};

@createModule('ProductCompareV2')
/**
 * product-compare module implementation.
 *
 * @author Lars-Olof Kreim <lars-olof.kreim@namics.com>
 */
export class ProductCompareV2 extends TerrificSpec {
	headlineSingleText: string;
	headlineMultiText: string;
	animationFrameId: number;
	curScrollTop: number;
	curScrollLeft: number;
	isFixed: boolean;
	topThreshold: number = 0;
	$ctx: JQuery; 

	/**
	 * start method, called on terrific bootstap
	 *
	 * @param {Object} resolve  function to call at the end of component start
	 * @returns {void}
	 */
	start(resolve: Function) {
		this.$ctx = $(this._ctx);
		$('html.l-product-compare').addClass('l-product-compare--improvements');
		const $headline = this.$ctx.find(`.${classes.headline}`);
		this.headlineSingleText = $headline.data('single-headline');
		this.headlineMultiText = $headline.data('multi-headline');
		this.updateHeadline();
		this.$ctx.find(`.${classes.removebutton}`).on('click', this.onRemoveClick.bind(this));
		this.$ctx.find(`.${classes.removeAllbutton}`).on('click', this.onRemoveAllClick.bind(this));
		this.updateColumnLength();
		this.$ctx.find(`.${classes.backbutton}`).on('click', () => {
			window.history.back();
		});
		this.highlightDifferences();
		this.showDifferences();
		this.$ctx.find(`.${classes.categoryTitle}`).on('click', this.onCategoryClick.bind(this));
		this.$ctx.find(`.${classes.tooltipBtn}`).on('click', this.onTooltipBtnClick.bind(this));
		this.$ctx.find(`.${classes.tooltipCloser}`).on('click', this.onTooltipCloserClick.bind(this));

		this.$ctx.find(`.${classes.rightControl}`).on('click', () => {
			this.onRightControlClick()
		});
		this.$ctx.find(`.${classes.leftControl}`).parent().addClass('disabled');
		this.$ctx.find(`.${classes.leftControl}`).on('click', () => {
			this.onLeftControlClick()
		});
		this.hiddenControlArrows();
		this.setStaticTable();
		$(window).on('scroll', this.onScroll.bind(this));
		$('body').on('scroll', this.onScroll.bind(this));
		$(window).on('resize', () => {
			this.$ctx.find(`.${classes.tooltipPopup}`).hide();
			this.setTitleTableHeight();
			this.setTableTopOffset();
			this.setMiniTitleHeight();
			this.hiddenControlArrows();
			this.setTableTopWidth();
		});

		const $products = $(`.${classes.productname}`, this.$ctx);
		this.$ctx.toggleClass(classes.tableHidden, $products.length <= 0);

		onBreakpointChange(() => {
			this.setStaticTable();
		});

		resolve();
	}
	/**
	 * stop method, called on terrific stop
	 *
	 * @returns {void}
	 */
	stop() { }

	/**
	 * method updates headline and sets count of products
	 *
	 * @returns {void}
	 */
	updateHeadline() {
		const $headline = this.$ctx.find(`.${classes.headline}`);
		const count = this.$ctx.find(`.${classes.productname}`).length;
		if (count === 1) {
			$headline.text(this.headlineSingleText);
		} else {
			$headline.text(this.headlineMultiText.replace(/\{0\}/, `${count}`));
		}
	}

	updateColumnLength() {
		const $categoryTh = this.$ctx.find(`.${classes.categoryTh}`);
		const count = this.$ctx.find(`.${classes.productname}`).length + 1;
		$categoryTh.attr('colspan', `${count}`);

		const $rightControl = this.$ctx.find(`.${classes.rightControl}`);
		if (count < $(window).width() / 250) {
			$rightControl.parent().hide();
		}
	}

	/**
	 * method handels remove click and therefor removes product from list and cookie
	 *
	 * @param {Object} ev  eventObject
	 * @returns {void}
	 */
	onRemoveClick(ev: Event) {
		ev.preventDefault();
		const $el = $(ev.currentTarget).closest(`.${classes.productname}`);
		const productId = $el.data('prod-id');

		// url won't overwrite cookies
		const currentQuery = window.location.search.substr(1);
		if (currentQuery.length > 0 && currentQuery.toLocaleLowerCase().indexOf("prdset") > -1) {
			this.removeFromUrl(productId);
		}
		else{
			ProductCompareHelper.removeProduct(productId);
		}
		
		this.$ctx.toggleClass(classes.tableHidden, $el.siblings().length <= 1);

		if ($el.siblings().length > 0) {
			this.$ctx.find(`.${classes.tablerow} > td:nth-child(${$el.index() + 1})`).remove();
		}

		this.updateHeadline();
		this.updateColumnLength();
		this.setTitleTableHeight();
		this.setTableTopOffset();
		this.setTableTopWidth();
		this.setMiniTitleHeight();
		this.highlightDifferences();
		this.hiddenControlArrows();
		this.setStaticTable();
		this.tableRemoveScoll();
		this.updateFavouritesBtnStatus();
	}

	onRemoveAllClick() {
		// url won't overwrite cookies
		const currentQuery = window.location.search.substr(1);
		if (currentQuery.length > 0 && currentQuery.toLocaleLowerCase().indexOf("prdset") > -1) {
			this.removeAllFromUrl();
		}
		else{
			ProductCompareHelper.removeAllProduct();
		}
		this.$ctx.addClass(classes.tableHidden);
		this.$ctx.find(`.${classes.tablerow} > td`).remove();

		this.updateHeadline();
		this.updateFavouritesBtnStatus();
	}

	onCategoryClick(ev: Event) {
		const categoryID = $(ev.currentTarget).data('toggle-parent');
		$(`.${classes.categoryTitle}[data-toggle-parent='${categoryID}']`).toggleClass(classes.categoryCollapse);
		$(`.${classes.categoryChild}[data-toggle-child='${categoryID}']`).toggleClass(classes.categoryCollapse);
		this.setTitleTableHeight();
	}

	onTooltipBtnClick(ev: Event) {
		const $tooltipPopup = this.$ctx.find(`.${classes.tooltipPopup}`);
		const currentTop = $(ev.currentTarget).offset().top - 14;
		const currentLeft = $(ev.currentTarget).offset().left + 14;
		$tooltipPopup.show();
		$tooltipPopup.css('top',currentTop)
		$tooltipPopup.css('left',currentLeft)
	}

	onTooltipCloserClick(ev: Event) {
		ev.preventDefault();
		$(ev.currentTarget).parents(`.${classes.tooltipPopup}`).hide();
	}
	/**
	 * Highlight all differences
	 *
	 * @returns {void}
	 */
	highlightDifferences() {
		const columns = this.$ctx.find(`.${classes.productname}`).length - 1;
		const $tableDataRow = this.$ctx.find(`.${classes.tableDataRow}`);
		const $titleTable = this.$ctx.find(`.${classes.titleTable}`);
		const $categoryTitle = this.$ctx.find(`.${classes.categoryTitle}`);
		if(columns > 0) {
			$categoryTitle.removeClass(classes.highlightRowActive);
			$tableDataRow.each((i, elem) => {
				let highlight: boolean = false;
				for (let num: number = 0; num < columns; ++num) {
					if ($(elem).find('td').eq(num).text() != $(elem).find('td').eq(num + 1).text()) {
						highlight = true;
						break;
					}
				}
				const categoryID = $(elem).data('toggle-child');
				const $curCategoryTitle = $(`.${classes.categoryTitle}[data-toggle-parent='${categoryID}']`);
				if (highlight == true) {
					$(elem).addClass(classes.highlightRowActive);
					$titleTable.find('tr').eq($(elem).index()).addClass(classes.highlightRowActive);
					$curCategoryTitle.addClass(classes.highlightRowActive);
					$titleTable.find('tr').eq($curCategoryTitle.index()).addClass(classes.highlightRowActive);
				} else {
					$(elem).removeClass(classes.highlightRowActive);
					$titleTable.find('tr').eq($(elem).index()).removeClass(classes.highlightRowActive);
				}
				highlight = false;
			});
		} else {
			$tableDataRow.removeClass(classes.highlightRowActive);
			$titleTable.find('tr').removeClass(classes.highlightRowActive);
			$categoryTitle.removeClass(classes.highlightRowActive);
		}
	}
	/**
	 * Show only the differences
	 *
	 * @returns {void}
	 */
	showDifferences() {
		let $checkboxElement = this.$ctx.find(`.${classes.showDifferences}`).find("input[type='checkbox']");
		const me = this.$ctx;
		const that = this;
		$checkboxElement.on("input propertychange", function(ev: any){
			const $target: any = $(ev.currentTarget);
			if ($target.is(":checked")) {
				me.addClass(classes.showDifferencesActive);
			} else {
				me.removeClass(classes.showDifferencesActive);
			}

			that.setTitleTableHeight();
			that.setTableTopOffset();
		});
	}
	/**
	 * method is called on scroll and debounces by requestAnimationFrame
	 *
	 * @returns {void}
	 */
	onScroll() {
		if (this.animationFrameId > 0) {
			window.cancelAnimationFrame(this.animationFrameId);
		}
		this.animationFrameId = window.requestAnimationFrame(() => {
			this.animationFrameId = 0;
			this.handleScrolling();
			//this.rightControlToggle();
		});
	}

	/**
	 * method handles scroll position and calls corresponding methods if scrollposition has changed till last processing
	 *
	 * @returns {void}
	 */
	handleScrolling() {
		const scrollTop = jQuery(window).scrollTop();
		const scrollLeft = document.body.scrollLeft;
		this.setTitleTableHeight();
		this.setTableTopOffset();
		this.setTableTopWidth();
		this.setMiniTitleHeight();

		this.curScrollTop = scrollTop;
		this.handleScrollTop();

		if (this.isFixed && scrollLeft !== this.curScrollLeft) {
			this.curScrollLeft = scrollLeft;
			this.handleScrollLeft();
		}
	}

	setMiniTitleHeight() {
		const $tabletop = this.$ctx.find(`.${classes.tabletop}`);
		const $miniTitle = this.$ctx.find(`.${classes.miniTitle}`);
		$miniTitle.find('th').height($tabletop.find('th').height());
	}

	setTitleTableHeight() {
		const $titleTable = this.$ctx.find(`.${classes.titleTable}`);
		$titleTable.find('th').each((i, elem) => {
			const $eIndex = $(elem).parent().index();
			$(elem).height(
				this.$ctx.find(`.${classes.tablerow}`).eq($eIndex).find('th').height()
			)
		});
	}

	setTableTopWidth() {
		const $table = this.$ctx.find(`.${classes.table}`);
		const $tabletop = this.$ctx.find(`.${classes.tabletop}`);
		$tabletop.width($table.width());
	}

	hiddenControlArrows() {
		const $tableContent = this.$ctx.find(`.${classes.tableContent}`);
		const $screenWidth = this.$ctx.width() - 48;
		const maxLength = $screenWidth / 250 - 1;
		const $products = $(`.${classes.productname}`, this.$ctx);
		if ($products.length <= maxLength) {
			this.$ctx.addClass(classes.arrowsHidden);
			$tableContent.css('margin-left', 0);
		} else {
			this.$ctx.removeClass(classes.arrowsHidden);
		}
	}

	setStaticTable() {
		const $products = $(`.${classes.productname}`, this.$ctx);
		const viewport = getCurrentBreakpoint() as string;
		if (viewport === 'small' && $products.length <= 2) {
			this.$ctx.addClass(classes.arrowsHidden);
		}
	}

	tableRemoveScoll() {
		const $tableContent = this.$ctx.find(`.${classes.tableContent}`);
		const $table = this.$ctx.find(`.${classes.table}`);
		const curMarginLeft = parseInt($tableContent.css("margin-left"));
		const maxScrollLeft = $table.width() - this.$ctx.width() + 96;
		if ( -curMarginLeft >= maxScrollLeft ) {
			$tableContent.css('margin-left', `-${maxScrollLeft}px`);
			this.$ctx.find(`.${classes.rightControl}`).parent().addClass('disabled');
		}
	}
	/**
	 * method click right arrow
	 *
	 * @returns {void}
	 */
	onRightControlClick() {
		this.$ctx.find(`.${classes.leftControl}`).parent().removeClass('disabled');
		this.tableScrollRight();
		this.setTitleTableHeight();

		const $titleTable = this.$ctx.find(`.${classes.titleTable}`);
		$titleTable.addClass(classes.fixedStateLeft);
	}

	tableScrollRight() {
		const $tableContent = this.$ctx.find(`.${classes.tableContent}`);
		const $table = this.$ctx.find(`.${classes.table}`);
		const curMarginLeft = parseInt($tableContent.css("margin-left"));
		const maxScrollLeft = $table.width() - this.$ctx.width() + 96;
		const nextScrollLeft = curMarginLeft - 250;

		if ( - curMarginLeft < maxScrollLeft - 250) {
			$tableContent.css('margin-left', nextScrollLeft + 'px');
		} else {
			$tableContent.css('margin-left', `-${maxScrollLeft}px`);
			this.$ctx.find(`.${classes.rightControl}`).parent().addClass('disabled');
		}
	}
	/**
	 * method click left arrow
	 *
	 * @returns {void}
	 */
	onLeftControlClick() {
		this.$ctx.find(`.${classes.rightControl}`).parent().removeClass('disabled');
		this.tableScrollLeft();
	}

	tableScrollLeft() {
		const $tableContent = this.$ctx.find(`.${classes.tableContent}`);
		const curMarginLeft = parseInt($tableContent.css("margin-left"));
		const nextScrollLeft = curMarginLeft + 250;
		if ( - curMarginLeft > 250) {
			$tableContent.css('margin-left', nextScrollLeft + 'px');
		} else {
			$tableContent.css('margin-left', 0);
			this.$ctx.find(`.${classes.leftControl}`).parent().addClass('disabled');
		}
	}
	/**
	 * method handles scroll top position and sets tableheader fix when threshold was crossed and viceversa
	 *
	 * @returns {void}
	 */
	handleScrollTop() {
		const $topRow = this.$ctx.find(`.${classes.tabletop}`);
		const viewport = getCurrentBreakpoint() as string;
		if (viewport === 'small') {
			this.topThreshold = 188;
		} else {
			this.topThreshold = 0;
		}

		if (this.curScrollTop > this.topThreshold) {
			if (!this.isFixed) {
				this.isFixed = true;
				this.$ctx.addClass(classes.fixedState);
				if (viewport === 'small') {
					this.handleScrollLeft();
				}
			}
		} else if (this.isFixed) {
			this.isFixed = false;
			this.$ctx.removeClass(classes.fixedState);
			$topRow.css('transform', 'translateX(0)');
		}
	}

	setTableTopOffset() {
		const $table = this.$ctx.find(`.${classes.table}`);
		const $topRow = $table.find(`.${classes.tabletop}`);
		$table.css('padding-top', `${$topRow.height()}px`);
	}

	/**
	 * method handles scroll left position and moves the tableheader accordingly
	 *
	 * @returns {void}
	 */
	handleScrollLeft() {
		const $table = this.$ctx.find(`.${classes.table}`);
		const $tabletop = $table.find(`.${classes.tabletop}`);
		$tabletop.css('transform', `translateX(-${this.curScrollLeft}px)`);
	}

	removeFromUrl(productId: string) {

		const currentQuery = window.location.search.substr(1);

		if (currentQuery.length > 0) {

			if (currentQuery.toLocaleLowerCase().indexOf("prdset") > -1) {

				const paramArr = currentQuery.split("&");

				paramArr.forEach((value: string, index: number, array: string[]) => {
					if (value.toLocaleLowerCase().indexOf("prdset") > -1) {
						const prdsetParamArr = value.split("=");
						if(prdsetParamArr.length > 1){
							const prdQuery = prdsetParamArr[1]; //eg: "04196414-12942213:US|00004582-05125840:US|04874625-10771105:US"
 
							const prdSegArr = prdQuery.split("|"); // "04196414-12942213:US"
							let queryArr = new Array();

							prdSegArr.forEach((v: string, i: number, a: string[]) => {
								if(v.indexOf(productId)==-1){
									queryArr.push(v); 
								}

							});

							if(queryArr.length > 0){
								let query = queryArr.join("|");
								query = `prdset=${query}`;				
								const search = `?${query}`; 
								history.pushState(null, null, search);
							}else{
								history.pushState(null, null, "?");
							}

						}
					}
				}); 

				 

			}

		}
	}

	removeAllFromUrl(){
		const currentQuery = window.location.search.substr(1);
		if (currentQuery.length > 0) {
			if (currentQuery.toLocaleLowerCase().indexOf("prdset") > -1) {
				history.pushState(null, null, "?");
			}
		}
	}

	updateFavouritesBtnStatus() {
		const query = window.location.search.substr(1);
		const $favouritesEle = $("html div[data-t-name='FavouriteButton']");

		if($favouritesEle.length > 0){
			const url = $favouritesEle.data("status-api-endpoint");
			const pageId = $favouritesEle.data("page-id");
			$.ajax({
				type: 'GET',
				url: url,
				dataType: 'json',
				data:
				{
					pageid: pageId,
					query: query
				},
				success: (response: any) => {

					if (response.isActive) {
						$("html").find(`button.${classes.favouriteBtn}`).addClass(classes.stateFavorBtnActive);
					} else {
						$("html").find(`button.${classes.favouriteBtn}`).removeClass(classes.stateFavorBtnActive);
					}
				},
				complete: () => {
	
				},
				error: (xhr: any, status: string, error: string) => {
					console.log(`after updating url of product-compare page, update status error, ${xhr.status}, ${xhr.statusText}, ${xhr.responseText}, ${error}`);
				}
			});
		}

	}
}
